/*
 * Algolia Recommend cross-sell for xhawi-shopify-theme.
 * Depends on: recommend.umd.js, recommend-js.umd.js, algolia-search.js (for AlgoliaTheme helpers).
 * Mount points (see snippets/algolia-recommend-mount.liquid):
 *   [data-algolia-recommend="related"|"fbt"|"trending"] with data-object-id.
 */
(function () {
  'use strict';

  var CFG = window.algoliaConfig || { enabled: false };
  if (!CFG.enabled) return;
  if (!CFG.surfaces || !CFG.surfaces.recommend) return;

  var recommendFactory = window['@algolia/recommend'];
  var recommendUI = window['@algolia/recommend-js'];
  if (!recommendFactory || !recommendUI) return;

  var recommendClient = recommendFactory(CFG.appId, CFG.searchApiKey);

  function cardTemplate(item, html) {
    var T = window.AlgoliaTheme;
    if (T && typeof T.productCardHTML === 'function') {
      // recommend-js uses html-template tagged function; fall back to raw string.
      return html([T.productCardHTML(item, { showVendor: true, showAddToCart: true })]);
    }
    return html([
      '<a href="/products/' +
        (item.handle || '') +
        '">' +
        (item.title || '') +
        '</a>',
    ]);
  }

  function mountRelated(el, objectId) {
    recommendUI.relatedProducts({
      container: el,
      recommendClient: recommendClient,
      indexName: CFG.indices.products,
      objectIDs: [objectId],
      maxRecommendations: el.getAttribute('data-max') || 8,
      templates: {
        item: cardTemplate,
        header: function (params, html) {
          var title = el.getAttribute('data-title') || 'You may also like';
          return html(['<h2 class="algolia-recommend__title h4">' + title + '</h2>']);
        },
      },
    });
  }

  function mountFBT(el, objectId) {
    recommendUI.frequentlyBoughtTogether({
      container: el,
      recommendClient: recommendClient,
      indexName: CFG.indices.products,
      objectIDs: [objectId],
      maxRecommendations: el.getAttribute('data-max') || 4,
      templates: {
        item: cardTemplate,
        header: function (params, html) {
          var title = el.getAttribute('data-title') || 'Frequently bought together';
          return html(['<h2 class="algolia-recommend__title h4">' + title + '</h2>']);
        },
      },
    });
  }

  function mountTrending(el) {
    recommendUI.trendingItems({
      container: el,
      recommendClient: recommendClient,
      indexName: CFG.indices.products,
      maxRecommendations: el.getAttribute('data-max') || 8,
      facetName: el.getAttribute('data-facet-name') || undefined,
      facetValue: el.getAttribute('data-facet-value') || undefined,
      templates: {
        item: cardTemplate,
        header: function (params, html) {
          var title = el.getAttribute('data-title') || 'Trending now';
          return html(['<h2 class="algolia-recommend__title h4">' + title + '</h2>']);
        },
      },
    });
  }

  function modelFor(type) {
    if (type === 'fbt') return 'bought-together';
    if (type === 'trending') return 'trending-items';
    return 'related-products';
  }

  // Hide an empty mount. When a section has no remaining Algolia recommendation
  // mounts, fall back to the legacy native "People Also Bought" block if one is
  // present (revealing it triggers its own fetch); otherwise collapse the section
  // so there's no dangling heading.
  function hideMount(el) {
    el.style.display = 'none';
    var section = el.closest('.sec__related-product, .algolia-recommend-section');
    if (!section) return;
    var stillVisible = Array.prototype.some.call(
      section.querySelectorAll('[data-algolia-recommend]'),
      function (m) {
        return m.style.display !== 'none';
      }
    );
    if (stillVisible) return;

    var legacy = section.querySelector('[data-algolia-recommend-legacy]');
    var primary = section.querySelector('[data-algolia-recommend-primary]');
    if (legacy) {
      // Algolia has nothing to show -> use the native recommendations instead.
      if (primary) primary.style.display = 'none';
      legacy.style.display = '';
    } else {
      section.style.display = 'none';
    }
  }

  // Pre-check the Recommend API so we only mount a widget when the model
  // exists AND returns results. This prevents empty widgets, dangling
  // headers, and unhandled 404 rejections when models aren't trained yet.
  function guardAndMount(el, type, objectId) {
    var req = {
      indexName: CFG.indices.products,
      model: modelFor(type),
      threshold: 0,
      maxRecommendations: Number(el.getAttribute('data-max')) || 8,
    };
    if (type !== 'trending') {
      if (!objectId) {
        hideMount(el);
        return;
      }
      req.objectID = String(objectId);
    }
    var pending;
    try {
      // @algolia/recommend v4 expects an array of queries (not { requests }).
      pending = recommendClient.getRecommendations([req]);
    } catch (e) {
      hideMount(el);
      return;
    }
    Promise.resolve(pending)
      .then(function (res) {
        var result = (res && res.results && res.results[0]) || {};
        var hits = result.hits || [];
        if (!hits.length) {
          hideMount(el);
          return;
        }
        try {
          if (type === 'related') mountRelated(el, objectId);
          else if (type === 'fbt') mountFBT(el, objectId);
          else mountTrending(el);
        } catch (e) {
          hideMount(el);
        }
      })
      .catch(function () {
        // Model not trained / index missing / network error -> hide cleanly.
        hideMount(el);
      });
  }

  function boot() {
    document.querySelectorAll('[data-algolia-recommend]').forEach(function (el) {
      if (el.__algoliaRecommendBound) return;
      el.__algoliaRecommendBound = true;
      var type = el.getAttribute('data-algolia-recommend');
      var objectId = el.getAttribute('data-object-id');
      guardAndMount(el, type, objectId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('algolia:added-to-cart', boot);
})();
